import { render } from "./backDashboard.vue?vue&type=template&id=03e05e43"
import script from "./backDashboard.vue?vue&type=script&lang=js"
export * from "./backDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__